import {Component, OnInit} from '@angular/core';
import {GlobalDataService} from '../services/global-data.service';
import {EmitterService} from '../services/emitter.service';
import {AdminService} from '../../admin/services/admin.service';
import {Router, ActivatedRoute} from '@angular/router';
import {GlobalVariable} from '../../../../app/config';
import {Headers, Http} from '@angular/http';

@Component({
  selector: 'app-preferences',
  templateUrl: '../views/preferences.component.html',
  styleUrls: ['../css/preferences.component.css']
})
export class PreferencesComponent implements OnInit {
  //public usrobj = JSON.parse(localStorage.getItem("user"))
  public usrobj = JSON.parse(sessionStorage.getItem("user"));
  public apiendpoint_url = GlobalVariable.FORDAPIEndPointURL;
  public timezonelist: any;
  public timezonename: any;
  public notifTime: any;
  public notificaion: boolean = true;
  public leadnotificaion: boolean = true;
  public casenotificaion: boolean = true;
  public morningnotificaion: boolean = true;
  public afternoonnotificaion: boolean = false;
  public eveningnotificaion: boolean = false;
  public notificaionTime = 'MORNING';
  public userObj: any;
  public responseMessage = "";
  //public userId = localStorage.getItem('userId');
  public userId = sessionStorage.getItem('userId');
  public hideNotifications: boolean = false;
  submitted: boolean = false

  constructor(public _adminService: AdminService, private _dataService: GlobalDataService, private _emitterService: EmitterService, private _router: Router, private http: Http) {
  }

  ngOnInit() {
    if (sessionStorage.getItem('roleId') == 'ADHVDR') {
      this.hideNotifications = true;
    }
    this.getTimezonelist();
    this.getPrefernceslist();
  }

  /**
   * @author Ciocan Vlad
   * @uses get the timezone list
   */
  getTimezonelist() {
    this._dataService.GetAjaxCall(this.apiendpoint_url + '/user/timezone/list', (result) => {
      this.timezonelist = result;
    });
  }

  getPrefernceslist() {
    this._adminService.getAdminDetails(this.userId, (result) => {

      this.userObj = result;
      this.timezonename = (this.userObj.timezone != null) ? this.userObj.timezone.id : '';
      this.notificaion = false;
      this.notificaionTime = this.userObj.notificationTime;
      this.setRadioNotification(this.notificaionTime);
      if (this.userObj.leadNotification) {
        this.leadnotificaion = true;
        this.notificaion = true;
      } else {
        this.leadnotificaion = false;
      }
      if (this.userObj.caseNotification) {
        this.casenotificaion = true;
        this.notificaion = true;
      } else {
        this.casenotificaion = false;
      }


    })
  }

  setRadioNotification(value) {
    //console.log(value)
    this.notificaionTime = value;
    if (value == "MORNING") {
      this.morningnotificaion = true;
      this.afternoonnotificaion = false;
      this.eveningnotificaion = false;
    } else if (value == "AFTERNOON") {
      this.morningnotificaion = false;
      this.afternoonnotificaion = true;
      this.eveningnotificaion = false;
    } else if (value == "EVENING") {
      this.morningnotificaion = false;
      this.afternoonnotificaion = false;
      this.eveningnotificaion = true;
    }
  }

  selectNotification(e, type) {
    if (type == "lead") {
      this.leadnotificaion = !!e.target.checked;
    } else if (type == "case") {
      this.casenotificaion = !!e.target.checked;
    } else {
      if (e.target.checked) {
        this.leadnotificaion = true;
        this.casenotificaion = true;
        this.notificaion = true;
      } else {
        this.leadnotificaion = false;
        this.casenotificaion = false;
        this.notificaion = false;
      }
    }
  }

  startSync() {
  }

  savePreference() {
    this.responseMessage = '';
    // this.userObj['userId']= Number(localStorage.getItem('userId')); // login id
    this.userObj['userId'] = Number(sessionStorage.getItem('userId')); // login id
    this.userObj.timezone = {id: this.timezonename};
    this.userObj.timeZoneId = this.timezonename;
    this.userObj.leadNotification = this.leadnotificaion;
    this.userObj.caseNotification = this.casenotificaion;
    this.userObj.notificationTime = this.notificaionTime;

    this._adminService.saveUser(this.userObj,(result)=>{
        if(result.statusCodes=='USER_SAVED_SUCCESSFULLY'){
            this.responseMessage='SUCCESS';
          const userObj = JSON.parse(localStorage.getItem("user"));
          userObj.timezone = this.timezonelist.filter(tz => tz.id ===  Number(this.timezonename))[0];
            localStorage.setItem("user", JSON.stringify(userObj));
            sessionStorage.setItem("user", JSON.stringify(userObj));
            this._dataService.getUserTimeZone();
            this._router.navigate(['dashboard']);
        }
        else
            this.responseMessage='FAILURE';
    })
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/housekeeping/components/preferences.component.ts